module.exports = __webpack_public_path__ + "img/asset8x1.ba80d152.png";